import React from "react";
import { Form } from "react-bootstrap";
import { Col } from "reactstrap";

const ShippingStatusFilter = ({
  filters,
  handleChange,
  filterKey = "is_active",
  options = [
    { value: "1", label: "نشط" },
    { value: "0", label: "غير نشط" },
  ],
}) => {
  return (
    <Col xs="3">
      <Form.Select
        value={filters[filterKey] || ""}
        className="form-select"
        onChange={(e) => handleChange(filterKey, e.target.value)}
      >
        <option value="">الحالة </option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Form.Select>
    </Col>
  );
};

export default ShippingStatusFilter;